import React, { useState } from 'react'
import { useForm } from 'react-hook-form';
import MovieCard from './MovieCard';

export default function Home() {
    let { register, handleSubmit, formState } = useForm()
    let [movie, setMovie] = useState(null)

    async function searchMovie(inputMovie) {
        let response = await fetch(`https://www.omdbapi.com/?t=${inputMovie.movieName}&apikey=9925aaf9`)
        let data = await response.json()
        setMovie(data)
    }

    return (
        <div className="container mt-4">
            <h3 className="text-center mt-3 display-5 mb-0">Movie Search</h3>
            <hr className="mt-1 mb-4 w-25 mx-auto" />            
            <form onSubmit={handleSubmit(searchMovie)}>
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6">
                        <input className="form-control mb-2" placeholder="Enter movie name" {...register("movieName", { required: { value: true, message: "Movie name is required" }})}/>
                        <div className="text-danger fst-italic">{formState.errors?.movieName?.message}</div>
                    </div>
                </div>
                <div className="row justify-content-center mt-2">
                    <div className="col-6 col-sm-4 col-md-3">
                        <button className="btn btn-primary w-100">Search</button>
                    </div>
                </div>
            </form>
            {movie && <MovieCard movieDetail={movie} />}
        </div>
    )
}